<form [formGroup]="formGroup">
  <!-- SKILLS SECTION -->
  <div formArrayName="skill">
    <div class="card-data">
      <h4>
        {{ "Skills" | translate }}
      </h4>

      <div class="row align-items-end" *ngFor="let skill of skills.controls; let i = index">
        <div class="col p-0 p-md-auto">
          <label>{{ "Skill" | translate }}</label>
          <input type="text" [formControlName]="i" placeholder="{{ 'Skill' | translate }}" />
        </div>

        <i class="col-auto bi bi-trash3 delete-icon" *ngIf="skills.length > 5" (click)="removeSkill(i)"></i>
      </div>

      <button class="border-button" type="button" (click)="addSkill()">
        {{ "Add New" | translate }}
        <i class="bi bi-plus-lg"></i>
      </button>

      <div class="error mt-2" *ngIf="skills.errors?.['minSkills'] && skills.touched">
        {{"You must add at least 5 skills"| translate}}
      </div>
    </div>
  </div>

  <!-- COURSES SECTION -->
  <div formArrayName="course">
    <div class="card-data">
      <h4>
        {{ "Courses" | translate }}
      </h4>

      <div class="row align-items-end" *ngFor="let course of courses.controls; let i = index">
        <div class="col p-0 p-md-auto">
          <label>{{ "Course" | translate }}</label>
          <input type="text" [formControlName]="i" placeholder="{{ 'Course Name' | translate }}" />
        </div>

        <i class="col-auto bi bi-trash3 delete-icon" *ngIf="courses.length > 1" (click)="removeCourse(i)"></i>
      </div>

      <button class="border-button" type="button" (click)="addcourse()">
        {{ "Add New" | translate }}
        <i class="bi bi-plus-lg"></i>
      </button>
    </div>
  </div>

  <!-- PROJECTS SECTION -->
  <div formArrayName="project">
    <div class="card-data">
      <h4>
        {{ "Projects" | translate }}
      </h4>

      <div *ngFor="let project of projects.controls; let i = index" [formGroupName]="i">
        <div class="proj-container mb-3">
          <!-- Project Name -->
          <div class="proj-style">
            <label>{{ "Project Name" | translate }}</label>
            <input type="text" formControlName="name" placeholder="{{ 'Enter project name' | translate }}" />
            <div class="error" *ngIf="project.get('name')?.touched && project.get('name')?.invalid">
              {{ "Project name is required" | translate }}
            </div>
          </div>

          <!-- Project Link -->
          <div class="proj-style">
            <label>{{ "Project Link" | translate }}</label>
            <input type="url" formControlName="link" placeholder="{{ 'Enter project link (optional)' | translate }}" />
          </div>

          <!-- Role -->
          <div class="proj-style">
            <label>{{ "Your Role" | translate }}</label>
            <input type="text" formControlName="role" placeholder="{{ 'Enter your role (optional)' | translate }}" />
          </div>

          <i class="col-auto bi bi-trash3 delete-icon del" *ngIf="projects.length > 1" (click)="removeProject(i)"></i>
        </div>
      </div>

      <button class="border-button" type="button" (click)="addProject()">
        {{ "Add New" | translate }}
        <i class="bi bi-plus-lg"></i>
      </button>
    </div>
  </div>

  <!-- CERTIFICATES SECTION -->
  <div class="card-data" formArrayName="certification">
    <h4>
      {{ "Certificates" | translate }}
    </h4>

    <div class="row align-items-end row-cols-md-3 row-col-1  g-2"
      *ngFor="let certificat of certificates.controls; let i = index" [formGroupName]="i">
      <div>
        <div class="  p-0 p-md-auto">
          <label>{{ "Certificate Name" | translate }}</label>
          <input type="text" formControlName="name" placeholder="{{ 'Certificate Name' | translate }}" />
        </div>
      </div>

      <div>
        <div class="   p-0 p-md-auto">
          <label>{{ "Organization Name" | translate }}</label>
          <input type="text" formControlName="organization" placeholder="{{ 'Enter organization name' | translate }}" />
        </div>
      </div>

      <div>
        <div class="  p-0 p-md-auto">
          <label>{{ "Date" | translate }}</label>
          <input type="date" formControlName="date" placeholder="{{ 'Select date' | translate }}" />
        </div>
      </div>


      <i class="col-auto bi bi-trash3 delete-icon" *ngIf="certificates.length > 1" (click)="removeCertificat(i)"></i>
    </div>

    <button class="border-button" type="button" (click)="addCertificat()">
      {{ "Add New" | translate }}
      <i class="bi bi-plus-lg"></i>
    </button>
  </div>

  <!-- LANGUAGES SECTION -->
  <div class="card-data" formArrayName="languages">
    <h4>
      {{ "Languages" | translate }}
    </h4>

    <div class="row align-items-end row-cols-md-2 row-cols-1 g-1"
      *ngFor="let lange of languages.controls; let i = index" [formGroupName]="i">
      <div>
        <div class=" p-0 p-md-auto">
          <label>{{ "Language" | translate }}</label>
          <input type="text" formControlName="name" placeholder="{{ 'Select Language' | translate }}" />
        </div>

      </div>
      <div>
        <div class=" p-0 p-md-auto">
          <label>{{ "Level" | translate }}</label>
          <p-dropdown [options]="'LANGUAGE_LEVELS' | translate" [placeholder]="'Select Level' | translate"
            formControlName="level" />
        </div>

      </div>

      <i class="col-auto bi bi-trash3 delete-icon" *ngIf="languages.length > 1" (click)="removeLanguage(i)"></i>
    </div>

    <button class="border-button" type="button" (click)="addLanguage()">
      {{ "Add New" | translate }}
      <i class="bi bi-plus-lg"></i>
    </button>
  </div>

  <!-- NAVIGATION BUTTONS -->
  <div class="next-container px-4">
    <button type="button" class="border-button m-3" (click)="onPrevious()">
      {{ "Back" | translate }}
    </button>
    <button type="button" class="gradient-button m-3" (click)="onNext()">
      <span *ngIf="!EditMode">{{ "Finish" | translate }} </span>
      <span *ngIf="EditMode">{{ "Edit" | translate }} </span>
    </button>
  </div>
</form>